import { Container, LoginInput as Input, InputLabel } from './Input.styles';

import { FormInputProps } from '../types';
import { InputContainer } from 'features/common/components/Form/Form.styles';
import { useFormContext } from 'react-hook-form';

const LoginInput = ({ id, name, label, ...rest }: FormInputProps) => {
	const { register } = useFormContext();

	return (
		<InputContainer hasError={false}>
			<InputLabel htmlFor={id ?? name} label={label} required={rest.required} />
			<Container>
				<Input id={id} {...register(name)} {...rest} />
			</Container>
		</InputContainer>
	);
};

export { LoginInput };
